<app-social-button
  e2eId="connect-with-google"
  [icon]="googleIcon"
  [disabled]="!(initialized$ | async) || (processing$ | async)"
  [isLoading]="processing$ | async"
  i2gTrackable
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
  (buttonClick)="signInToGoogle()"
>
</app-social-button>
